import { Agreement, Move, Mover } from "@/types";
import { baseApi } from "../baseApi";

type AgreementResponse = {
  agreement: Agreement;
  move: Move;
  mover: Mover;
};

const agreementsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    signAgreement: builder.mutation({
      query: ({ ref, move_identifier, data }) => {
        const params = new URLSearchParams();
        if (ref) params.append("ref", ref);
        params.append("move_identifier", move_identifier);

        return {
          url: `agreements/sign?${params.toString()}`,
          method: "POST",
          body: data,
        };
      },
    }),

    getAgreement: builder.query<AgreementResponse, string>({
      query: (ref) => `agreements/${ref}`,
    }),
  }),
});

export const { useSignAgreementMutation, useGetAgreementQuery } = agreementsApi;

export default agreementsApi;
